export default __webpack_public_path__ + "static/screen-siren-logo-f7f38d70e75b43efa30da381ab02705e.png";